import { getEnvironmentVar } from '../getEnvironmentVar';

function getFqdn(): string {
  return window.location.hostname;
}

function removeFirstSubdomainPrefix(partialFqdn: string): string {
  const regex: RegExp = /^[a-z\d]+-/;

  if (regex.test(partialFqdn)) {
    partialFqdn = partialFqdn.split('-')[1];
  }

  return partialFqdn;
}

// the hell is this doing?
export function getApiServerUrl(): string {
  const apiUrl = getEnvironmentVar('REACT_APP_API_URL');

  if (apiUrl) {
    return apiUrl;
  }

  return `${window.location.protocol}//api-${removeFirstSubdomainPrefix(
    getFqdn()
  )}`;
}

export function getRedirectUri(mandant: string): string {
  const clientUrl = getEnvironmentVar('REACT_APP_BEH_FRONTEND_URL');

  if (clientUrl) {
    return `${clientUrl}/${mandant}`;
  }

  return `${window.location.protocol}//${removeFirstSubdomainPrefix(
    getFqdn()
  )}/${mandant}`;
}

export function getMandant(): string {
  return window.location.pathname.substring(1).split('/')[0];
}

export function getLogoutUrl(): string | undefined {
  return getEnvironmentVar('REACT_APP_LOGOUT_URL');
}
